import { useCurrentUser } from "@/features/login/hooks/useCurrentUser";
import Programa from "./Programa";
import { BrainCircuit } from "lucide-react";

export default function Programas() {
  const { usuarioInfo } = useCurrentUser();
  const fechaActual = new Date();

  // Filtrar programas que no han terminado (fechaFin >= fecha actual)
  // y que estén activos y no ocultos (tanto el programa como el AprendizPrograma)
  // y que tengan al menos una actividad asignada al aprendiz
  const programas = (usuarioInfo?.programas || []).filter(
    (aprendizPrograma) => {
      const fechaFin = new Date(aprendizPrograma.programa.fechaFin);
      const programaValido =
        !aprendizPrograma.programa.isOculto &&
        aprendizPrograma.programa.isActivo &&
        !aprendizPrograma.isOculto &&
        aprendizPrograma.isActivo;

      // Verificar que el programa tenga al menos una actividad asignada al aprendiz
      const tieneActividadesAsignadas = aprendizPrograma.programa.actividadPrograma.some(
        (actividad) => actividad.actividadAprendiz && actividad.actividadAprendiz.length > 0
      );

      return fechaFin >= fechaActual && programaValido && tieneActividadesAsignadas;
    },
  );

  return (
    <>
      <section className="mb-8 px-4 md:px-8">
        <div className="relative bg-gradient-to-r from-white to-[var(--primary)]/10 dark:from-[var(--background-muted)] dark:to-[var(--primary)]/25 rounded-2xl shadow-lg/30 p-6 md:p-8 overflow-hidden border border-gray-200 dark:border-gray-700">
          <div className="relative z-10 w-full">
            <h1 className="font-bold text-2xl md:text-3xl text-[var(--foreground)] mb-3">
              Este espacio es para aplicar lo aprendido
            </h1>
            <p className="text-[var(--foreground)] opacity-70 text-base md:text-lg leading-relaxed">
              Aquí trabajarás retos prácticos basados en tu contexto real.
              Recibirás retroalimentación personalizada para mejorar tu
              desempeño en el trabajo.
            </p>
          </div>

          {/* Icono que sobresale */}
          <div className="absolute -right-12 top-1/2 -translate-y-1/2">
            <BrainCircuit
              className="text-[var(--secondary)] opacity-40"
              size={160}
              strokeWidth={1.5}
            />
          </div>
        </div>
      </section>

      <section className="mb-6 px-4 md:px-8">
        <h2 className="font-extrabold tracking-[0.2em] text-lg md:text-xl text-[var(--foreground)] dark:brightness-150 uppercase">
          Mis programas activos
        </h2>
      </section>

      {programas.map((aprendizPrograma) => (
        <Programa
          key={aprendizPrograma.id}
          aprendizPrograma={aprendizPrograma}
        />
      ))}
    </>
  );
}
